/**
 * @generated SignedSource<<dc34b4c29829ce159de2b23ba025e00c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutTemplates_UserPreferences$data = {
  readonly userPreferences: {
    readonly __id: string;
    readonly showDateFieldAssociationMessageByIssueKey: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewLayoutTemplates_UserPreferences";
};
export type ui_issueViewLayoutTemplates_UserPreferences$key = {
  readonly " $data"?: ui_issueViewLayoutTemplates_UserPreferences$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutTemplates_UserPreferences">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutTemplates_UserPreferences",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "issueKey",
              "variableName": "issueKey"
            }
          ],
          "kind": "ScalarField",
          "name": "showDateFieldAssociationMessageByIssueKey"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "39d7b75279216376c8e0f38cf128e423";

export default node;
